import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {AgentService} from "../../../services";
import {fetchAllAgents, fetchAllSubAgents} from "./agents-list.slice";
import AuthService from "app/services/auth.service";
import {ROLES} from "app/constants/roles";

interface DeactivateAgentStateParams {
    id: string;
    onSuccess?: Function;
    onError?: Function;
}

const isUserAgent = (): boolean => {
  const user = AuthService.handleAuthentication();
  if (!user) return false;
  // @ts-ignore
  const authorities = user.authorities || [];
  const isAdmin = authorities.includes(ROLES.ROLE_ADMIN);
  const isAgent = authorities.includes(ROLES.ROLE_AGENT) && !isAdmin;
  return isAgent;
};

export const deactivateAgent = (params: DeactivateAgentStateParams) => async (dispatch: Dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await AgentService.deactivateAgent(params.id);
        if (response.status >= 200 && response.status < 300) {
            dispatch(setSuccess(true));
            const isAgent = isUserAgent();
            const lang = localStorage.getItem('i18nextLng');
            const message = lang === 'en' 
                ? (isAgent ? 'Sub-Agent deactivated successfully!' : 'Agent deactivated successfully!')
                : (isAgent ? 'Sub-Agjenti u çaktivizua me sukses!' : 'Agjenti u çaktivizua me sukses!');
            dispatch(successMsg(message));
            if (params.onSuccess) params.onSuccess();
            dispatch(setError(""));
            // @ts-ignore
            dispatch(isAgent ? fetchAllSubAgents() : fetchAllAgents());
        }
        dispatch(setLoading(false));
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
    }
};

interface CreateAgentSlice {
    success: boolean;
    error: string;
    loading: boolean;
}

const initialState: CreateAgentSlice = {
    error: '',
    success: false,
    loading: false
}

const stateSlice = createSlice({
    name: 'agent/deactivate-agent',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setSuccess: (state, action) => {
            state.success = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        }
    }
})

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;